import { Component } from "@angular/core";
import "@components/line-chart/line-chart";
@Component({
	selector: "app-fm-line-chart",
	templateUrl: "./fm-line-chart.component.html",
})
export class FmLineChartComponent {}
